import { render } from "./HelloWorld.vue?vue&type=template&id=b9167eee&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=b9167eee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9167eee"]])

export default __exports__